<template>
  <div>
    <material-button
      class="d-none"
      data-bs-toggle="modal"
      data-bs-target="#addExistingUpsellItem"
      id="show-modal-add-existing-upsell-item"
    ></material-button>
    <div id="custom-overlay" class="custom-modal-overlay"></div>
    <div
      class="modal fade"
      id="addExistingUpsellItem"
      tabindex="-1"
      aria-hidden="true"
      style="z-index: 1056"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Add Upsell Items
            </h5>
            <i
              style="cursor: pointer"
              class="material-icons btn-close-modal"
              data-bs-dismiss="modal"
              aria-label="Close"
              >clear</i
            >
          </div>
          <div class="modal-body" style="overflow-y: unset">
            <div class="group-option-list">
              <label class="fw-bold" for
                >Item No <span class="text-danger ms-2">*</span></label
              >
              <Multiselect
                :createOption="true"
                :searchable="true"
                :mode="'tags'"
                v-model="itemNo"
                :canClear="true"
                placeholder="Enter Item No"
                :addOptionOn="['enter']"
                :onCreate="onCreate"
                :clearOnBlur="false"
                :max="1"
                @select="onItemSelect"
               />
              <div class="mt-1">
                 Enter key to add item number. Only one item allowed.
               </div>
              <div class="mt-3 text-danger">
                <div v-for="(message, index) in messageErr" :key="index">
                  {{ message }}
                </div>
              </div>
            </div>
              <div class="group-option-list">
               <label class="fw-bold" for
                 >Price
                 <span class="text-danger ms-2" v-if="!hasModifiers">*</span></label
               >
               <div v-if="isPricedByOptions" class="text-xs text-secondary">
                 This item has no price of its own — it is added at $0.00 and its
                 options carry the whole price.
               </div>
               <template v-else>
                 <Multiselect
                   :createOption="false"
                   :searchable="true"
                   :mode="'single'"
                   v-model="price"
                   :options="priceOptions"
                   :canClear="true"
                   placeholder="Select Price"
                   :clearOnBlur="false"
                 />
                 <div class="mt-1 text-xs text-secondary" v-if="hasModifiers">
                   This item has options. Customers pick them when they add it, and
                   the option prices are added on top of the price above.
                 </div>
               </template>
             </div>
            <div class="group-option-list">
              <label class="fw-bold mb-1" for="">Show this item at</label>
              <div class="form-check mb-1">
                <input
                  class="form-check-input"
                  type="radio"
                  id="addUpsellScopeAll"
                  :checked="isAllBranches"
                  @change="setScope(true)"
                />
                <label class="form-check-label" for="addUpsellScopeAll">
                  All branches using this menu set
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  id="addUpsellScopeSelected"
                  :checked="!isAllBranches"
                  @change="setScope(false)"
                />
                <label class="form-check-label" for="addUpsellScopeSelected">
                  Selected branches only
                </label>
              </div>
              <div class="mt-2" v-if="!isAllBranches">
                <Multiselect
                  v-model="branchIds"
                  mode="tags"
                  :close-on-select="false"
                  :searchable="true"
                  :options="branchOptions"
                  placeholder="Select branches"
                  :canClear="true"
                />
                <div class="mt-1">
                  <span class="is-invalid" v-if="isBranchRequired"
                    >Select at least one branch.</span
                  >
                  <span class="text-xs text-secondary" v-else
                    >Set a different price per branch afterwards from the
                    item's Branches menu.</span
                  >
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-end mt-5">
              <material-button
                class="mx-2 btn btn-sm btn-background"
                @click="addExistingItem()"
              >
                Add
              </material-button>
              <material-button
                class="mx-2 btn btn-sm btn-background"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                Cancel
              </material-button>
            </div>
          </div>
        </div>
      </div>
      <material-loading :active="loaderActive" />
    </div>
    <div class="position-fixed top-1 end-1 z-index-9999 message-success">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
  </div>
</template>
<script>
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import "@vueform/multiselect/themes/default.css";
import MenusetService from "../services/product/menuset.service";
import $ from "jquery";

export default {
  name: "modal-add-existing-upsell-item",
  components: {
    MaterialLoading,
    MaterialSnackbar,
    MaterialButton,
    Multiselect,
  },
  props: {
    setId: {
      type: Number,
      required: true,
    },
    keyReload: {
      type: String,
      required: true,
    },
    // SF275 — [{ value: branchId, label: branchName }] for this menu set.
    branchOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      snackbar: null,
      message: "",
      loaderActive: false,
      itemNo: [],
      price: null,
      messageErr: [],
      priceOptions: [],
      // SF275 — an item nobody narrows is offered everywhere, as it always was.
      isAllBranches: true,
      branchIds: [],
      isBranchRequired: false,
      // An item with options can be upsold; the price above is its base price.
      hasModifiers: false,
      // ...unless its own price keys are all zero, in which case the options carry the
      // whole price and there is no base for the merchant to choose.
      isPricedByOptions: false,
    };
  },
  methods: {
    async onCreate(option) {
      if (option) {
        const tags = option.value
          .split(",")
          .map((tag) => tag.trim())
          .filter((tag) => tag);
        var newTags = [];

        tags.forEach((tag) => {
          if (!this.itemNo.includes(tag)) {
            newTags.push({
              value: tag,
              label: tag,
            });
          }
        });

        if (newTags.length > 0) {
          const firstTag = newTags[0];
          await this.checkItem(firstTag.value);
        }

        return newTags;
      }

      return false;
    },

    async checkItem(itemNo) {
      try {
        this.showLoader();

        const dataForm = {
          item_no: itemNo
        };

        const response = await MenusetService.checkItem(dataForm);

        if (response.data.result.isSuccess) {
          const item = response.data.data;
          this.hasModifiers = !!item.has_modifiers;
          this.isPricedByOptions = !!item.is_priced_by_options;

          if (item.price_list && item.price_list.length > 0) {
            this.priceOptions = item.price_list;
            this.price = null; // Reset price selection
          } else {
            this.priceOptions = [];
            this.price = null;

            // Nothing to pick is expected when the options carry the price; it is only
            // worth warning about when the item should have had one.
            if (!this.isPricedByOptions) {
              this.snackbar = "warning";
              this.message = "No price options available for this item";
              this.setTimeOutNotification();
            }
          }
        } else {
          this.priceOptions = [];
          this.price = null;
          this.hasModifiers = false;
          this.isPricedByOptions = false;
          this.snackbar = "danger";
          this.message = response.data.result.message || "Failed to get item price list";
          this.setTimeOutNotification();
        }
      } catch (error) {
        console.error("Error getting item price list:", error);
        this.priceOptions = [];
        this.price = null;
        this.hasModifiers = false;
        this.isPricedByOptions = false;
        this.snackbar = "danger";
        this.message = "An error occurred while getting item price list";
        this.setTimeOutNotification();
      } finally {
        this.hideLoader();
      }
    },

    async onItemSelect(selectedOption) {
      if (selectedOption && selectedOption.value) {
        await this.checkItem(selectedOption.value);
      }
    },

    setScope(isAll) {
      this.isAllBranches = isAll;
      this.isBranchRequired = false;
    },

    addExistingItem() {
      if (!this.isAllBranches && !this.branchIds.length) {
        this.isBranchRequired = true;
        return;
      }

      // Used to return silently on either of these, so the button simply did nothing and
      // left the merchant guessing which field it was unhappy about.
      if (!this.itemNo.length) {
        this.messageErr = ["Please enter an item number."];
        return;
      }

      // SF276 — an item with options may be added at $0.00, because its price lives on the
      // options. For every other item the price is still required, exactly as before; it just
      // says so now instead of the button doing nothing.
      if (!this.hasModifiers && this.price === null) {
        this.messageErr = ["Please select a price."];
        return;
      }

      this.messageErr = [];

      this.showLoader()
      var dataForm = {
        set_id: this.setId,
        item_no: this.itemNo,
        // Only reachable with a null price for an item with options, where 0 is a real
        // choice rather than a missing answer.
        item_price: this.price === null ? 0 : this.price,
        is_all_branches: this.isAllBranches,
        branches: this.isAllBranches
          ? []
          : this.branchIds.map((branchId) => ({ branch_id: branchId })),
      };

      MenusetService.addUpsellItems(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.messageErr = response.data.data;

            if (this.messageErr.length == 0) {
              $(".btn-close-modal").click();
              this.$emit("reload-upsell-items", "Add upsell item success");
            }
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.setTimeOutNotification();
          this.hideLoader();
        }
      );
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
  },
     watch: {
     keyReload() {
       this.itemNo = [];
       this.price = null;
       this.priceOptions = [];
       this.messageErr = [];
       // SF275 — reopen defaults back to "every branch", not to the last pick.
       this.isAllBranches = true;
       this.branchIds = [];
       this.isBranchRequired = false;
       this.hasModifiers = false;
       this.isPricedByOptions = false;
     },
   },
};
</script>
